function getVideoElement(container) {
  return container.find('video').get(0);
}

let playlistVids = jQuery('.up-next');

playlistVids.each(function () {
  const vidEl = getVideoElement(jQuery(this));
  if (vidEl) {
    vidEl.width = 210;
    vidEl.height = 118;
  }
});

function swapVids() {
  const clickedVid = jQuery(this);

  // Update quote for TOW pages
  if (window.location.pathname.includes('/tow/')) {
    const currentQuote = jQuery('blockquote.current');
    currentQuote.removeClass('current');
    const clickedQuote = jQuery('#tq' + clickedVid.attr('id').slice(2));
    clickedQuote.addClass('current');
  }

  // Pull titles
  const clickedVidTitle = clickedVid.find('h3').text();
  const clickedVidTitleTrader = clickedVid.find('p').text();

  // Grab video elements
  const clickedPlayer = getVideoElement(clickedVid);
  const vidList = clickedVid.closest('.vid-list');
  const vidHome = vidList.siblings('.current-vid');
  const currentVid = vidHome.find('.current');
  const currentPlayer = getVideoElement(currentVid);

  // Stop current video
  if (currentPlayer) currentPlayer.pause();

  // Resize clicked up to hero
  const vidHomeWidth = vidHome.width();
  if (clickedPlayer) {
    clickedPlayer.width = vidHomeWidth;
    clickedPlayer.height = vidHomeWidth * 0.5625;
  }
  clickedVid.appendTo(vidHome);

  // Update hero titles
  vidHome.children('.current-title').text(clickedVidTitle);
  vidHome.children('.current-trader').text(clickedVidTitleTrader);

  // Move old hero down to playlist
  currentVid
    .off('click.upNext')
    .appendTo(vidList)
    .removeClass('current')
    .addClass('up-next');
  if (currentPlayer) {
    currentPlayer.width = 210;
    currentPlayer.height = 118;
  }
  currentVid.on('click.upNext', swapVids);

  // Promote clicked to current
  clickedVid.removeClass('up-next').addClass('current').off('click.upNext');
  if (clickedPlayer) clickedPlayer.play();

  // Re-bind playlist items
  playlistVids = jQuery('.up-next');

  // Stop the last playlist video after a delay
  const lastVidEl = getVideoElement(playlistVids.last());
  if (lastVidEl) {
    setTimeout(() => lastVidEl.pause(), 3000);
  }
}

playlistVids.on('click.upNext', swapVids);
